import React from 'react';
import '../../../styles/howitworkfaq.scss';

export default function HowitWorks(props) {
	return (
		<div>
			<br />
			<div className="row w-100 justify-content-start">
				<div className="col-auto pr-0" >
					<div className="how-list d-flex justify-content-center align-items-center d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: `${props.partner && props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
						<span className="" >1</span>
					</div>
				</div>
				<div className="col">
					<div className="how-content-faq">
						<li>
							<b> Get pre-approved quickly and easily</b>: Fill out {(props?.partner?.url_path === 'wrenews' || props?.partner?.url_path === 'jw&!$329654') ? <span style={{ fontWeight: 'bolder', cursor: 'pointer', textDecoration: 'underline' }} onClick={(e) => { window.scrollTo(0, 0) }}>this</span> : 'the'} 5-minute application on our website, and {(props?.partner?.url_path === 'wrenews' || props?.partner?.url_path === 'jw&!$329654') ? 'we' : 'our partner, Calque,'} will send you a purchase price guarantee (PPG) within {(props?.partner?.url_path ==='warburton')?'2-10':'3-5'} business days. The PPG assures you that if your house doesn’t sell on the open market within a specified timeframe ({(props?.partner.url_path === 'wrenews' || props?.partner?.url_path === 'jw&!$329654') ? 'up to' : 'usually'} {(props?.partner.url_path === 'wrenews' || props?.partner?.url_path === 'jw&!$329654' || props?.partner?.url_path ==='warburton' ) ? '150' : '120'} days in most markets), Calque will buy it for a mutually agreed upon, fair price. Once you accept the PPG, you will select and work with a Calque lending partner to pre-approve you for your new home loan.
						</li>
					</div>
				</div>
			</div>
			<div className="row w-100 justify-content-start">
				<div className="col-auto pr-0">
					<div className="how-list d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: `${props.partner && props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
						<span className="" >2</span>
					</div>
				</div>
				<div className="col">
					<div className="how-content-faq">
						{(props?.partner?.url_path === "jw&!$329654" || props?.partner?.url_path === "jasonwalter") ?
							<li>
								<b>Make competitive offers with confidence</b>: Start submitting appealing offers that aren't contigent on the sale of your home on new home prospects. Once your offer is accepted on your new home, your Calque lending partner will finalize the underwriting process and use the equity you’ve already accrued in your original home to give you the down payment for the new home and a conventional loan on the new property.
							</li>
							:
							<li>
								<b>Make competitive offers with confidence</b>: Start submitting appealing, non-contingent offers that are like cash on new home prospects. Once your offer is accepted on your new home, your Calque lending partner will finalize the underwriting process and use the equity you’ve already accrued in your original home to give you the down payment for the new home and a conventional loan on the new property.
							</li>
						}
					</div>
				</div>
			</div>
			<div className="row w-100 justify-content-start">
				<div className="col-auto pr-0">
					<div className="how-list d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: `${props.partner && props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
						<span className="" >3</span>
					</div>
				</div>
				<div className="col">
					<div className="how-content-faq">
						<li>
							<b>Move and prep your original home for sale</b>:
							{(props?.partner?.url_path === 'wrenews' || props?.partner?.url_path === 'jw&!$329654') ? ' Move into your new home and then we’ll work with you to make repairs and stage the original home for sale. When your original home is ready for sale, you and your real estate agent list it on the open market.' : ' Move into your new home and then we’ll work with you to make repairs and stage the original home for sale. During this time, you will not be out-of-pocket for two mortgages at once. While you will need to process monthly payments on both homes, The Trade-In Mortgage™ allows you to use the equity in your current home to make the payments on that home. When your original home is ready for sale, we will help you list it on the open market.'}
						</li>
					</div>
				</div>
			</div>
			<div className="row w-100 justify-content-start">
				<div className="col-auto pr-0">
					<div className="how-list d-flex justify-content-center align-items-center" style={{ color: 'white', backgroundColor: `${props.partner && props.partner.primary_color ? props.partner.primary_color : '#042F70'}` }}>
						<span className="" >4</span>
					</div>
				</div>
				<div className="col">
					<div className="how-content-faq">
						<li>
							<b>Sell your original home and save</b>: Sell your original house on the open market for maximum value. If you aren’t able to sell and close on it within the specified time frame (up to 150 days in most markets), Calque will buy it for the agreed upon price. Either way, you move forward with a conventional loan on your new home.
						</li>
					</div>
				</div>
			</div>
		</div>
	)
}